"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Gevorg Avetisyan on 9/14/2020.
 */
var DataPointType;
(function (DataPointType) {
    DataPointType[DataPointType["BASELINE"] = 0] = "BASELINE";
    DataPointType[DataPointType["TARGET"] = 1] = "TARGET";
    DataPointType[DataPointType["ACTUAL"] = 2] = "ACTUAL";
    DataPointType[DataPointType["BASELINE8"] = 101] = "BASELINE8";
    DataPointType[DataPointType["TARGET8"] = 102] = "TARGET8";
    DataPointType[DataPointType["ACTUAL8"] = 103] = "ACTUAL8";
    DataPointType[DataPointType["NONE8"] = 104] = "NONE8";
    DataPointType[DataPointType["BASELINECALC"] = 109] = "BASELINECALC";
    DataPointType[DataPointType["TARGETCALC"] = 110] = "TARGETCALC";
    DataPointType[DataPointType["ACTUALCALC"] = 111] = "ACTUALCALC";
})(DataPointType = exports.DataPointType || (exports.DataPointType = {}));
//# sourceMappingURL=data-point-type.enum.js.map